<template>
  <el-dialog title="更换地址" :visible="visible" width="680px" append-to-body :close-on-click-modal="false" @update:visible="$emit('update:visible', $event)" @open="load">
    <div v-loading="loading">
      <el-alert title="历史轨迹和事件会保留，更换后重新计算目的地围栏与剩余路线。" type="info" :closable="false" show-icon />
      <el-form label-width="100px" size="small" class="address-form" @submit.native.prevent>
        <el-form-item label="运单号"><span>{{ row.waybillNo }}</span></el-form-item>
        <el-form-item label="更换节点"><el-radio-group v-model="nodeType"><el-radio-button label="start" :disabled="Number(row.transportStatus) !== 0">起点</el-radio-button><el-radio-button label="end">目的地</el-radio-button></el-radio-group></el-form-item>
        <el-form-item label="地址"><el-input v-model.trim="node.address" placeholder="请通过地图选点确认地址"><el-button slot="append" icon="el-icon-location" @click="pickerVisible = true">地图选点</el-button></el-input></el-form-item>
        <el-form-item label="坐标"><coordinate-input v-model="node.lonlat" placeholder="经度,纬度" /></el-form-item>
        <el-form-item label="围栏半径"><el-input-number v-model="node.fenceRadius" :min="50" :max="5000" :step="50" /> 米</el-form-item>
        <el-form-item label="联系人"><el-input v-model.trim="node.contactName" maxlength="50" /></el-form-item>
        <el-form-item label="联系电话"><el-input v-model.trim="node.contactPhone" maxlength="30" /></el-form-item>
      </el-form>
    </div>
    <span slot="footer"><el-button @click="$emit('update:visible', false)">取消</el-button><el-button type="primary" :loading="saving" :disabled="loading" v-permission="'waybill:edit'" @click="submit">确认更换</el-button></span>
    <waybill-location-picker :visible.sync="pickerVisible" :address="node.address" :lon-lat="node.lonlat" :area-codes="areaCodes" :area-name="node.areaName" @confirm="applyLocation" />
  </el-dialog>
</template>

<script>
import { changeWaybillAddress, getWaybillDetail, isRequestSuccess } from './lingdongApi'
import WaybillLocationPicker from './WaybillLocationPicker.vue'
import CoordinateInput from './CoordinateInput.vue'

const emptyNode = () => ({ address: '', lonlat: '', fenceRadius: 500, areaCodes: '', areaName: '', contactName: '', contactPhone: '' })
export default {
  name: 'WaybillAddressChange',
  components: { WaybillLocationPicker, CoordinateInput },
  props: { visible: Boolean, row: { type: Object, default: () => ({}) } },
  data() { return { loading: false, saving: false, nodeType: 'end', nodes: { start: emptyNode(), end: emptyNode() }, pickerVisible: false, requestId: 0, loadedWaybillNo: '' } },
  watch: {
    visible(value) { if (!value) { this.requestId += 1; this.loadedWaybillNo = ''; this.loading = false; this.pickerVisible = false } }
  },
  beforeDestroy() { this.requestId += 1 },
  computed: {
    node() { return this.nodes[this.nodeType] },
    areaCodes() { return String(this.node.areaCodes || '').split(',').filter(Boolean) }
  },
  methods: {
    async load() {
      const id = ++this.requestId
      const transportNo = this.row.waybillNo
      this.loadedWaybillNo = ''
      this.loading = true
      this.nodeType = 'end'
      this.nodes = { start: emptyNode(), end: emptyNode() }
      try {
        const res = await getWaybillDetail({ transportNo })
        if (id !== this.requestId || !this.visible || transportNo !== this.row.waybillNo) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '读取运单失败')
        const waybill = res.data.waybill || res.data
        ;['start', 'end'].forEach(type => {
          this.nodes[type] = { address: waybill[`${type}Address`] || '', lonlat: waybill[`${type}Lonlat`] || '', fenceRadius: Number(waybill[`${type}FenceRadius`]) || 500, areaCodes: waybill[`${type}AreaCodes`] || '', areaName: waybill[`${type}AreaName`] || '', contactName: waybill[`${type}ContactName`] || '', contactPhone: waybill[`${type}ContactPhone`] || '' }
        })
        this.loadedWaybillNo = transportNo
      } catch (error) {
        if (id === this.requestId) { this.$message.error(error.msg || error.message || '读取运单失败'); this.$emit('update:visible', false) }
      } finally { if (id === this.requestId) this.loading = false }
    },
    applyLocation(location) {
      this.node.lonlat = location.lonLat
      this.node.address = location.address || this.node.address
      this.node.areaCodes = (location.areaCodes || []).join(',')
      this.node.areaName = location.areaName || ''
    },
    async submit() {
      if (this.saving || this.loading || this.loadedWaybillNo !== this.row.waybillNo) return
      const id = this.requestId
      const transportNo = this.loadedWaybillNo
      const coordinates = this.node.lonlat.split(',').map(Number)
      if (!this.node.address || coordinates.length !== 2 || !coordinates.every(Number.isFinite) || Math.abs(coordinates[0]) > 180 || Math.abs(coordinates[1]) > 90) {
        this.$message.warning('请填写地址并选择有效的坐标')
        return
      }
      this.saving = true
      try {
        const res = await changeWaybillAddress({ transportNo, [this.nodeType]: { ...this.node } })
        if (!isRequestSuccess(res)) throw new Error(res.msg || '更换地址失败')
        this.$message.success('地址已更换')
        if (id === this.requestId) this.$emit('update:visible', false)
        this.$emit('success')
      } catch (error) { this.$message.error(error.msg || error.message || '更换地址失败') } finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.address-form { margin-top: 20px; }
</style>
